import { __assign, __makeTemplateObject, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { SortArrowUpSmall } from '../../icons/icons/SortArrowUpSmall';
import { SortArrowDownSmall } from '../../icons/icons/SortArrowDownSmall';
import { SortArrowSmall } from '../../icons/icons/SortArrowSmall';
import { IconButton } from '../../Button/Button';
var getIcon = function (sort) {
    if (!sort)
        return SortArrowSmall;
    return sort === 'asc' ? SortArrowDownSmall : SortArrowUpSmall;
};
var getLabel = function (sort) {
    if (!sort)
        return 'Neutral';
    return sort === 'asc' ? 'Ascending' : 'Descending';
};
export var TableSortIcon = styled(function (_a) {
    var sort = _a.sort, _b = _a.size, size = _b === void 0 ? 'label' : _b, _c = _a.hoverBackgroundColor, hoverBackgroundColor = _c === void 0 ? 'blue-tint-95' : _c, _d = _a.hoverColor, hoverColor = _d === void 0 ? 'interaction' : _d, props = __rest(_a, ["sort", "size", "hoverBackgroundColor", "hoverColor"]);
    return (React.createElement(IconButton, __assign({ Icon: getIcon(sort), label: getLabel(sort), size: size, hoverBackgroundColor: hoverBackgroundColor, hoverColor: hoverColor }, props)));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
TableSortIcon.propTypes = {
    sort: PropTypes.oneOf(['asc', 'desc']),
};
var templateObject_1;
//# sourceMappingURL=TableSortIcon.js.map